<!--  -->
<template>
<div class='container'>
    <div class="item" v-for="(item,i) in msg" :key="i">
        <div class="title">{{item.title}}</div>
        <div class="content">{{item.content}}</div>
        <div class="date">{{item.start_time}}</div>
    </div>
    <div class="empty" v-show="msg.length == 0">
        <img src="../../assets/image/message.png" alt="">
        <div class="hint">没有新消息</div>
    </div>
    <!-- <div class="item">
        <div class="title">课程报名成功</div>
        <div class="content">通知内容通知内容，通知内容通知内容通知内容通
知内容通知内容通知内容，通知内容通知内容。</div>
        <div class="date">2019-03-03 &nbsp;&nbsp;&nbsp;10:00</div>
    </div> -->
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import moment from 'moment'//解析时间戳
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    page:1,
    per_page:10,
    msg:[],//消息
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    // 获取消息
    getMsg(){
        this.$http.getSystemMessage({
            page:this.page,
            per_page:this.per_page
        }).then(res=>{
            this.$store.commit('hideLoading')
            if(res.status == 1){
                let list = res.data.data
                for (let index = 0; index < list.length; index++) {
                    if(list[index].send_time){
                        list[index].start_time = moment(list[index].send_time * 1000).format('YYYY-MM-DD HH:mm')
                    }
                }
                this.msg = list
            }
        })
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    this.$store.commit('showLoading')
    this.getMsg()
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    padding: 16px 18px;
    box-sizing: border-box;
    .empty{
        img{
            width:250px;
            height: 180px;
        }
    }
    .item{
        width: 100%;
        background-color: #fff;
        padding: 15px 16px;
        box-sizing: border-box;
        margin-bottom: 10px;
        .title{
            font-size: 17px;
            color: #071228;
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #EAEAEA;
        }
        .content{
            font-size: 14px;
            color: #666666;
            margin-top: 15px;
        }
        .date{
            font-size: 13px;
            color: #999999;
            margin-top: 13px;
        }
    }
}
</style>